import React, {memo} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';
import fallbackImg from "../../../assets/img/asset_placeholder.png";
import {CardImg} from "reactstrap";

const PreviewColumn = memo(({template}) => {

  return (
    <td className={'text-center'}>
      <CardImg
        style={{maxWidth: '128px', maxHeight: '128px', height: 'auto', width: 'auto'}}
        className={classNames({
          'product-image-detail': true,
          'img-blackwhite': !template.status,
        })}
        src={template.previews[0]?.url}
        onError={({currentTarget}) => {
          currentTarget.onerror = null;
          currentTarget.src = fallbackImg;
          currentTarget.classList.remove('card-image-fit')
        }}
      />
    </td>
  );
});

PreviewColumn.propTypes = {
  template: PropTypes.object.isRequired,
};

export default PreviewColumn;
